import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, map, debounceTime } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { UpdateTracPage, UpdateTracPageField } from '../action-creators';
import { UPDATE_TRAC_PAGE_FIELD } from '../actions';
import TracPage from '@services/tracpage/types/trac-page';

export const autosaveEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) => {
  return action$.pipe(
    ofType<Action, UpdateTracPageField<any, any>>(UPDATE_TRAC_PAGE_FIELD),
    withLatestFrom(state$),
    debounceTime(2000),
    map(([_, state]) => {
      return new UpdateTracPage<TracPage>(
        'tracpage',
        state.tracpage.artistPage as TracPage
      );
    })
  );
};
